import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const filters = (currencyText) => [
  {
    title: 'محدوده تاریخ صدور',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(30, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'نوع حساب',
    label: 'نوع حساب',
    keyName: 'block',
    id: 1611,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: BLOCK_OPTIONS,
    },
  },
  {
    title: 'شرح سند',
    label: 'شرح سند',
    keyName: 'description',
    id: 1427,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'محدوده‌ مبلغ درآمد',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'محدوده‌ مبلغ',
    id: {
      start: 1578,
      end: 1579,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'شماره سند',
    label: 'شماره سند',
    keyName: 'documentId',
    id: 1427,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;

const BLOCK_OPTIONS = [
  {
    label: 'مسدودی',
    value: true,
  },
  {
    label: 'غیر مسدودی',
    value: false,
  },
];
